import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function SeasonProgressChart({ data = [] }) {
  if (!data.length) {
    return (
      <div className="flex h-[320px] items-center justify-center rounded-[1.5rem] bg-slate-50 text-sm font-bold text-slate-500 dark:bg-white/[0.03] dark:text-white/50">
        Pas assez de données pour afficher une progression par saison.
      </div>
    );
  }

  return (
    <div className="h-[360px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ top: 10, right: 12, left: -12, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" opacity={0.35} />
          <XAxis dataKey="season" tick={{ fontSize: 12 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />

          <Line
            type="monotone"
            dataKey="competitions"
            name="Compétitions"
            stroke="#0284c7"
            strokeWidth={3}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />

          <Line
            type="monotone"
            dataKey="combats"
            name="Combats"
            stroke="#64748b"
            strokeWidth={3}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />

          <Line
            type="monotone"
            dataKey="victoires"
            name="Victoires"
            stroke="#22c55e"
            strokeWidth={3}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />

          <Line
            type="monotone"
            dataKey="podiums"
            name="Podiums"
            stroke="#f59e0b"
            strokeWidth={3}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SeasonProgressChart;